import { ScreenContext } from '@/contexts/ScreenContext';
import { getPromotionToolState } from '@/modules/main/selector';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useContext, useRef } from 'react';
import { useSelector } from 'react-redux';
import { DisplayBalance } from '../DisplayBalance';
import { PromotionEventType } from '@/modules/popup/promotiontool/components/PromotionDialog';
import PromotionIndicator from '@/modules/popup/promotiontool/components/PromotionIndicator';

export const HeaderInfo = () => {
    const { Id: EventId, EventType } = useSelector(getPromotionToolState);
    const { isLandscape } = useContext(ScreenContext);
    const ref = useRef<HTMLDivElement>(null);

    return (
        <>
            <Stack
                direction={'row'}
                alignItems={'center'}
                sx={{
                    overflowX: 'scroll',
                    overflowY: 'hidden',
                    maxWidth: isLandscape ? 'unset' : '45vw',
                    scrollbarWidth: 'none',
                }}
            >
                <Stack direction={'column'}>
                    {EventId > 0 &&
                        EventType !== PromotionEventType.Unknown && (
                            <PromotionIndicator
                                refHeight={ref.current?.clientHeight}
                            />
                        )}
                    <Box ref={ref}>
                        <DisplayBalance />
                    </Box>
                </Stack>
            </Stack>
        </>
    );
};
